export default "__VITE_ASSET__d84d6535__"